import { useRef, useEffect } from "react";
import styles from "./FormTextarea.module.css";

export default function FormTextarea({label, name, defaultText="", required, pattern, errorMsg, setFormValidity}) {

    const inputRef = useRef();
    const id = label.replaceAll(" ","_");

    useEffect(() => {
        setFormValidity(formValidity => {
            return {...formValidity, [id]:false}
        })
    },[setFormValidity,id])

    const handleValidation = function() {
        let valid = true;
        const value = inputRef.current.value;

        if(required && value === ""){
            inputRef.current.setCustomValidity("Textarea cannot be empty");
            inputRef.current.reportValidity();
            valid = false;
        }
        else if(!pattern.test(value) && value !== ""){
            inputRef.current.setCustomValidity(errorMsg);
            inputRef.current.reportValidity();
            valid = false;
        }
        else{
            inputRef.current.setCustomValidity("");
        }

        setFormValidity(formValidity => {
            return {...formValidity, [id]:valid}
        })
    }

    return (
        <div className={styles.textareaInput}>
            <label htmlFor={id}>{required && <span>*</span>} {label}</label>
            <textarea id={id} name={name} ref={inputRef} onChange={handleValidation} onBlur={handleValidation} defaultValue={defaultText}></textarea>
        </div>
    );
} 